import React, { useEffect } from "react";
import { useMatch } from "react-router-dom";
import GlobalUploadManager from "./GlobalUploadManager";
import { startLoaderValidationRuntime } from "../services/loaderValidation/loaderValidationRuntime";

const LoaderValidationRuntimeBridge: React.FC = () => {
  useEffect(() => startLoaderValidationRuntime(), []);
  return null;
};

const StudioImportRuntime: React.FC = () => {
  // Match the auth Route itself (including trailing slashes), independent of
  // query parameters and session state. Unmount before import hooks can run;
  // the persisted upload store continues to belong to the Studio window.
  const isPluginAuthRoute = useMatch("/figma-plugin-auth");
  if (isPluginAuthRoute) return null;

  return (
    <>
      <LoaderValidationRuntimeBridge />
      <GlobalUploadManager />
    </>
  );
};

export default StudioImportRuntime;
